import { render, staticRenderFns } from "./add.vue?vue&type=template&id=a7a1ae80&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=a7a1ae80&prod&lang=css"
import style1 from "./add.vue?vue&type=style&index=1&id=a7a1ae80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a1ae80",
  null
  
)

export default component.exports